import React from 'react';

import clsx from 'clsx';

import useStyles from './TextButton.styles';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactElement | string;
  className?: string;
};

const TextButton: React.FC<Props> = ({ children, className, ...rest }) => {
  const styles = useStyles();
  return (
    <button className={clsx(styles.button, className)} type='button' {...rest}>
      {children}
    </button>
  );
};

export default TextButton;
